module.exports = __webpack_public_path__ + "static/media/more.ce70f27c.svg";